import { Tooltip } from '@mui/material'
import { FunctionComponent, useState } from 'react'
import React from 'react'
import { toast } from 'react-toastify'

export const CopyToClipboardTooltip: FunctionComponent<{
    title: string
    copiedTitle: string
    children: any
}> = ({ title, copiedTitle, children }) => {
    const [tooltipTitle, setTooltipTitle] = useState(title)

    const handleClick = () => {
        toast.success(copiedTitle)
    }

    return (
        <>
            <Tooltip title={tooltipTitle}>
                <span
                    onClick={() => {
                        handleClick()
                        setTooltipTitle(copiedTitle)
                        setTimeout(() => {
                            setTooltipTitle(title)
                        }, 1000)
                    }}
                >
                    {children}
                </span>
            </Tooltip>
        </>
    )
}
